import { Injectable, inject } from '@angular/core';

import { AzureStorageService } from '~/services/azure-storage.service';
import { DocumentFinderApiService } from '~/services/document-finder-api.service';
import { FoundDocument } from '~/models/document-finder.models';

export interface DocumentFile {
    /** File name to use inside the ZIP, including its extension */
    fileName: string;
    blob: Blob;
}

/**
 * Fetches the binary content of a document (connected Azure folder, else GET documents/{id}/content).
 */
@Injectable({ providedIn: 'root' })
export class DocumentFileService {
    private api = inject(DocumentFinderApiService);
    private azure = inject(AzureStorageService);

    public async getFile(doc: FoundDocument): Promise<DocumentFile> {
        if (doc.signavioFlowId) {
            return { fileName: doc.name + '.svg', blob: await this.api.downloadSignavio(doc.signavioFlowId) };
        }
        const azureBlob = await this.azure.getBlob(doc.id);
        if (azureBlob) { return { fileName: this.fileName(doc), blob: azureBlob }; }
        const blob = await this.api.getContent(doc.id);
        if (!blob) { throw new Error('API is not configured.'); }
        return { fileName: this.fileName(doc), blob };
    }

    /** Document name with its real extension (names from the index do not always include it). */
    public fileName(doc: FoundDocument): string {
        const ext = '.' + doc.ext;
        return doc.name.toLowerCase().endsWith(ext) ? doc.name : doc.name + ext;
    }
}
